import React from "react";
import { Link } from "react-router-dom";
import { Col } from "antd";
import { StorageUnit as StorageUnitType } from "/app/src/models";
/**
 * Renders a storage unit component.
 *
 * @param {Object} props - The properties object.
 * @param {StorageUnitType} props.storageUnit - The storage unit object containing type, id, and name.
 * @returns {JSX.Element} The rendered storage unit component.
 */
export default function StorageUnits({
  storageUnit,
}: {
  storageUnit: StorageUnitType;
}) {
  return (
    <Col span={8}>
      <div className={`storageUnit type_${storageUnit.type}`}>
        <h4>
          <Link to={`/explorer/storage_units/${storageUnit.id}`}>
            {storageUnit.name}
          </Link>
        </h4>
      </div>
    </Col>
  );
}
